import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ordersAPI, subscriptionsAPI } from '../services/api';

const money = (n) => `£${Number(n).toFixed(2)}`;

const Pricing = () => {
  const [items, setItems] = useState([]);
  const [subs, setSubs] = useState(null);

  useEffect(() => {
    ordersAPI.getPricing().then((r) => setItems(r.data.filter((i) => i.active === undefined || i.active === 1))).catch(() => {});
    subscriptionsAPI.getPricing().then((r) => setSubs(r.data)).catch(() => {});
  }, []);

  const services = subs
    ? [
        { key: 'laundry', title: '🧺 Laundry', meta: 'Wash, dry & fold' },
        { key: 'shirts_trousers', title: '👔 Shirts & Trousers', meta: 'Washed & pressed' }
      ]
    : [];

  return (
    <div className="container">
      <h1 className="section-title">Simple, honest pricing</h1>
      <p className="section-sub">No hidden fees. Free collection and delivery on every order.</p>

      {/* Subscriptions */}
      {subs && (
        <>
          <h2 style={{ marginBottom: '0.3rem' }}>Laundry subscriptions</h2>
          <p style={{ color: 'var(--ink-soft)', marginBottom: '1.2rem' }}>Regular collections at a set price. Weekly or fortnightly — cancel anytime.</p>
          <div className="cards-grid" style={{ marginBottom: '3rem' }}>
            {services.map((s) => (
              <div className="card" key={s.key}>
                <div className="feature-icon">{s.title.split(' ')[0]}</div>
                <h3>{s.title.replace(/^\S+\s/, '')}</h3>
                <p style={{ marginBottom: '1rem' }}>{s.meta}</p>
                {[1, 2, 3].map((t) => {
                  const w = subs[s.key]?.weekly?.[t];
                  if (!w) return null;
                  return (
                    <div className="summary-line" key={t}>
                      <span>Tier {t} — {w.description}</span>
                      <strong>{money(w.price)}<span style={{ fontWeight: 500, color: 'var(--ink-soft)' }}>/wk</span></strong>
                    </div>
                  );
                })}
                <Link to="/register" className="btn btn-primary btn-block" style={{ marginTop: '1rem' }}>Subscribe</Link>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Dry cleaning */}
      <h2 style={{ marginBottom: '0.3rem' }}>Dry cleaning &amp; pressing</h2>
      <p style={{ color: 'var(--ink-soft)', marginBottom: '1.2rem' }}>Pay per item — perfect for one-off cleans.</p>
      <div className="card" style={{ padding: '0.5rem 1.5rem' }}>
        {items.map((i) => (
          <div className="item-row" key={i.id}>
            <div>
              <strong>{i.item_name}</strong>
              {i.description && <div style={{ fontSize: '0.85rem', color: 'var(--ink-soft)' }}>{i.description}</div>}
            </div>
            <span className="price-small">{money(i.price)}</span>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: '2.5rem' }}>
        <Link to="/register" className="btn btn-accent btn-lg">Get started</Link>
      </div>
    </div>
  );
};

export default Pricing;
